// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerSignInStyles } from "@vanmeter/Overrides/Widgets/Common/HeaderSignIn";
import { fontConfig } from "@vanmeter/XDL/constants";
import { color, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

headerSignInStyles.logInButton = {
    sizeVariant: "large",
    typographyProps: {
        fontFamily: fontConfig.secondaryFontFamily,
        css: css`
            white-space: nowrap;
            ${xScreen("lte", "md")} {
                color: ${color("common.ui1")};
                font-size: ${fontConfig.regular.size}px;
                line-height: ${fontConfig.smallSingleLine.lineHeight};
                &:hover {
                    color: ${color("common.ui17")};
                }
            }
        `,
    },
    css: css`
        margin-left: 16px;
        ${xScreen("lte", "md")} {
            margin-left: 0;
        }
    `,
};

headerSignInStyles.myAccountTooltip = {
    tooltipContent: {
        css: css`
            border: 1px solid ${color("common.border")};
            border-top: 0;
            box-shadow: none;
            border-radius: 0;
            max-width: 430px;
            width: 430px;
            padding: 12px 0;
        `,
    },
};

headerSignInStyles.signInDrawerStyles = {
    drawerContent: {
        css: css`
            overflow-y: auto;
            ${({ isMounted }: any) =>
                isMounted &&
                css`
                    right: 0;
                `}
        `,
    },
};
